import { render, staticRenderFns } from "./DIconArrowDown.vue?vue&type=template&id=76aed53a&scoped=true&"
import script from "./DIconArrowDown.vue?vue&type=script&lang=js&"
export * from "./DIconArrowDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aed53a",
  null
  
)

export default component.exports